import { Route, Routes } from "react-router-dom";
import { ReEntry } from "./ReEntry.js";
import { ReProject } from "./ReProject.js";
import { ReProjectsList } from "./ReProjectsList.js";

/** FIX-011 / RE Stage 4: `/generate/create/re/*` - a fourth, isolated Create path; VIDEO, IMAGE and REEL are untouched. */
export function ReRoutes({ tenantId }: { readonly tenantId: string }) {
  return (
    <Routes>
      <Route index element={<ReEntry tenantId={tenantId} />} />
      <Route path="projects" element={<ReProjectsList tenantId={tenantId} />} />
      <Route path="projects/:projectId" element={<ReProject tenantId={tenantId} />} />
    </Routes>
  );
}
